import React from 'react';
import {Link} from "react-router-dom";

export function Contact() {


    return (

        <div className={"container  py-5 text-start  w-100"}>

            <div className={"row"}>

                <div className={"col"}>

                    <h4><strong>Velkommen til Karakterboost!</strong></h4>
                    <p>
                         Her tilbyr vi kurs til privatister og videregående elever. Vi tilbyr en rekke kurs innenfor både realfag og samfunnsfag.
                        Kursene er laget av universitetstudenter og tidligere privatister med lang erfaring innen å ta opp fag. Våre kurs tilbyr rask og effektiv, personlig
                        læring for å gi dine karakterer ett boost!
                    </p>

                    <p>
                        Kursene er basert på notater fra privatistelever som har gitt andre elever gode resultater ved mange andledninger. Kursene er fortsatt i notatform,
                        men videreutviklet til å være mer interaktive. Dermed får du med deg det viktigste, samtidig som du får en bedre og interaktiv opplevelse.
                        Kursene inneholder tekst, bilder, spill, interaktive moduler og oppgaver. Noen oppgaver er flervalgsoppgaver, mens andre er fri tekst. Står du fast
                        i en oppgave, eller synes noe i kurset er vanskelig, kan du alltid spørre vår AI assistent, som er trent opp til å svare på spørsmål relatert til
                        fagstoffet.
                    </p>

                    <div className={"border border-dark border-2 p-3 mb-4"}>
                        <h4 className={"text-decoration-underline"}>Kontakt</h4>
                        <div className={"row"}>
                            <p className={"col-3 mb-1 "}><strong>Firma:</strong></p>
                            <p className={"col mb-1"}>Karakterboost AS</p>
                        </div>
                        <div className={"row"}>
                            <p className={"col-3 mb-1 "}><strong>E-post:</strong></p>
                            <p className={"col mb-1"}>support@karakterboost.no</p>
                        </div>
                        <div className={"row"}>
                            <p className={"col-3 mb-1 "}><strong>Telefon:</strong></p>
                            <p className={"col mb-1"}>971 17 885</p>
                        </div>
                        <div className={"row"}>
                            <p className={"col-3 mb-1 "}><strong>Org.nr:</strong></p>
                            <p className={"col mb-1"}>934 522 699</p>
                        </div>
                    </div>

                    <p>
                       Les mer om våre <Link to={"/info/terms"} > salgsbetingelser</Link>
                    </p>

                    <p>
                        Hvordan behandler vi dine personoppysninger? Les mer om dette i vår
                        <Link to={"/info/privacy"} > personvernerklæring</Link>
                    </p>

                </div>
                <div className={"col"}>

                    <div className={""}>
                        <img className={"w-100 rounded "} src={"https://media.istockphoto.com/id/1361844238/photo/high-school-professor-assisting-her-students-in-e-learning-on-laptop-in-the-classroom.jpg?s=612x612&w=0&k=20&c=RUI6d64h2mszvH2CicmeSCp_sZowN1p81dtuctGIaRM="}/>
                    </div>

                </div>
            </div>



        </div>

    );


}